export default {
  AddOffer: 'افزودن پیشنهاد',
  notFound: 'صفحه یافت نشد',
  OrderCancel: 'سفارش کنسل شد',
  UserRachedSource: 'کاربر به مبدا رسید',
  RequestStart: 'درخواست شروع شد',
  TheSourceDestinationSelected: 'مبدا و مقصد انتخاب شده است',
  ThisCargoIsNotSupportedByFreight: 'این سفارش توسط پروژه پشتیبانی نمی شود',
  Amount: 'قیمت پایه',
  Accept: '!تایید شد',
  AssignCommodity: 'اختصاص کالا',
  AssignCar: 'اختصاص خودرو',
  ActiveLoads: 'سفارش‌های فعال',
  Confirmed: 'تایید شد',
  CustomerConfirmed: 'منتظر تایید',
  Canceled: 'کنسل شده',
  CurrentLoads: 'شروع سرویس',
  CompanyApproval: 'پذیرفته شده',
  ChoseLatAndLong: 'مبدا و مقصد را انتخاب کنید',
  Current: 'جاری',
  Currency: 'قیمت',
  Car: 'خودرو',
  CarModelFeature: 'نوع خودرو',
  CancelType: 'نوع کنسلی',
  Active: 'فعال‌',
  EditCoordinates: 'ویرایش مختصات',
  ElevatorHasCargo: 'آسانسور حمل بار دارد',
  ExtraTariff: 'سایر',
  ExcessCost: 'هزینه مازاد',
  EndLoads: 'پایان',
  CompletingSelectbox: 'پرکردن باکس ها',
  CustomerAccept: 'تایید مشتری',
  DestinationCity: 'شهر مقصد',
  DestinationProvince: 'استان مقصد',
  OriginAddress: 'آدرس مبدا',
  OriginCity: 'شهر مبدا',
  OriginProvince: 'استان مبدا',
  Details: 'جزئیات',
  DetailsCost: 'جزییات قیمت',
  DestinationAddress: 'آدرس مقصد',
  DateAndTimeOfRequest: 'تاریخ و ساعت درخواست',
  Driver: 'راننده',
  DriverTraining: 'مراحل کار راننده',
  DisplayBearings: 'نمایش پروژه ها',
  DistanceFromEntranceDoorToCar: 'فاصله درب ورودی تا خودرو (m)',
  ReachOrgin: 'رسیدن به مبدا',
  Refrigerator: 'یخچال و فریزر',
  RevertAccept: 'ابطال پروژه',
  Brand: 'نام پروژه',
  BearingType: 'نوع پروژه',
  Companylist: 'لیست پروژه ها ',
  Capacity: 'ظرفیت',
  Cost: 'هزینه',
  Count: 'تعداد',
  Cars: 'خودرو',
  CarLoad: 'بارگیر',
  CarCount: 'تعداد خودرو',
  CompleteProfile: 'تکمیل مشخصات',
  CompanyName: 'نام پروژه',
  CustomerName: 'نام مشتری',
  CustomerMobile: 'تلفن همراه مشتری',
  CompanyDiscountAmount: ' تخفیف پروژه',
  CompanyFee: 'سهم پروژه',
  End: 'پایان',
  SmallCost: 'هزینه',
  DistanceToLift: 'فاصله درب ورودی تا خودرو',
  DischargeDayPart: 'زمان تخلیه',
  Finish: 'پایان',
  BackToFinish: 'ابطال پایان',
  DelivererName: 'نام تحویل دهنده',
  Floor: 'طبقه',
  Feedback: 'بازخورد',
  FinishService: 'پایان سرویس',
  FreeAmount: 'تخفیف',
  Unit: 'واحد',
  UserRequestTime: 'تاریخ اسباب‌کشی',
  TransfereeName: 'نام تحویل گیرنده',
  Transferee: 'تحویل گیرنده',
  TypeOfCargo: 'نوع بار',
  TechnicalLaborer: 'نیروی فنی',
  RegistTime: 'زمان ثبت سفارش',
  Range: 'محدوده بار',
  CustomerOffer: 'قیمت پیشنهادی',
  Orgin: 'مبدا',
  Start: 'شروع',
  BackToStart: 'ابطال شروع',
  SelectCompany: 'تعیین پروژه',
  PayableAmount: 'مبلغ قابل پرداخت',
  MobileDeliveryService: 'موبایل تحویل دهنده',
  MonetaryValue: 'ارزش بار',
  DeliveryService: 'تحویل دهنده',
  Instrument: ' وسیله ها',
  Image: 'عکس',
  Items: 'اقلام',
  Loadsteps: 'مراحل حمل سفارش',
  Loads: 'نوع بار',
  LengthMeter: 'طول بار(متر)',
  HeightMeter: 'ارتفاع بار(متر)',
  Status: 'وضعیت',
  StartService: 'شروع سرویس',
  SelectSourceDestination: 'انتخاب مبدا و مقصد',
  SelectRequiredItems: 'انتخاب اقلام مورد نیاز',
  StartLoading: 'شروع بارگیری',
  NewRequest: 'درخواست جدید',
  ReachDestination: 'رسیدن به مقصد',
  NumberOfWorkersWithoutEquipment: 'رتعداد کارگر بدون وسیله',
  WebsiteDiscountAmount: 'تخفیف بادپا',
  Mobilereceiverdelivery: 'موبایل تحویل گیرنده',
  NewService: 'سرویس جدید',
  NextLevel: 'مرحله بعد',
  websiteFee: 'سهم بادپا',
  Worker: 'کارگر',
  Download: 'بارگیری',
  Score: 'امتیاز',
  Successful: 'موفقیت',
  TotalAmount: 'مبلغ کل',
  Tv: 'تلویزیون',
  Destination: 'مقصد',
  Mirror: 'آیینه و بوفه',
  Laborer: 'کارگر',
  Load: 'نوع بار',
  OperationWasSuccessfull: 'عملیات با موفقیت انجام شد ',
  Offers: 'پیشنهادات قیمت',
  Plate: 'پلاک',
  Package: 'بسته بندی',
  WeightTon: 'وزن (تن)',
  WidthMeter: 'عرض بار(متر)',
  DischargeDate: 'تاریخ تخلیه',
  PriceUpdate: 'بروزرسانی قیمت',
  LoadAppropriation: 'تخصیص سفارش',
  DocumentType: 'نوع سند حمل',
  ShipmentGeneralInformationEditedSuccessfully:
    'اطلاعات کلی سفارش با موفقیت ویرایش شد',
  CargoParameters: 'پارامتر های سفارش',
  GeographicalAttributes: 'مشخصات جغرافیایی',
  LoadingAddress: 'مبدا',
  DischargeAddress: 'مقصد',
  EstimatedDistance: 'مسافت تقریبی',
  EstimatedDuration: 'زمان تقریبی',
  InIntercityFurnitureCityOfOriginAndDestinationShouldNotBeTheSame:
    'در اسباب‌کشی بین شهری، شهر مبدا و مقصد نباید یکسان باشد',
  InIntercityCargoCityOfOriginAndDestinationShouldNotBeTheSame:
    'در بار سنگین، شهر مبدا و مقصد نباید یکسان باشد',
  InIUrbanFurnitureCityOfOriginAndDestinationShouldBeTheSame:
    'در اسباب‌کشی شهری، شهر مبدا و مقصد باید یکسان باشد',
  InUrbanCargoCityOfOriginAndDestinationShouldBeTheSame:
    'در بار شهری، شهر مبدا و مقصد باید یکسان باشد',
  CompleteLoadingLocationInformation: 'اطلاعات تکمیلی مبدا',
  CompleteDischargeLocationInformation: 'اطلاعات تکمیلی مقصد',
  CompleteOriginAddressInformation: 'اطلاعات تکمیلی آدرس مبدا',
  CompleteDestinationAddressInformation: 'اطلاعات تکمیلی آدرس مقصد',
  OriginPlate: 'پلاک مبدا',
  DestinationPlate: 'پلاک مقصد',
  OriginFloor: 'طبقه مبدا',
  DestinationFloor: 'طبقه مقصد',
  OriginDistanceFromEntranceDoorToCar: 'فاصله درب ورودی تا خودرو در مبدا',
  DestinationDistanceFromEntranceDoorToCar: 'فاصله درب ورودی تا خودرو در مقصد',
  ChooseOriginAndDestinationOnMap: 'مبدا و مقصد را بر روی نقشه مشخص کنید',
  ShipmentCarInformationEditedSuccessfully:
    'اطلاعات خودرو سفارش با موفقیت ویرایش شد',
  ThisModelOfCarCanNotBeUseForThisOrderJustDeleteAllowed:
    'این نوع خودرو برای این سفارش قابل استفاده نمی باشد، تنها امکان حذف وجود دارد',
  TransportTechnicalForceInformationWasSuccessfullyEdited:
    'اطلاعات نیروی فنی سفارش با موفقیت ویرایش شد',
  ShipmentItemListEditedSuccessfully: 'لیست اقلام سفارش با موفقیت ویرایش شد',
  NoFeedbackHasBeenRecordedForThisShipmentYet:
    'هنوز بازخوردی برای این سفارش ثبت نشده است',
  RecordFeedback: 'ثبت بازخورد',
  NoResponseHasBeenRecordedForThisFeedbackYet:
    'هنوز پاسخی برای این بازخورد ثبت نشده است',
  RecordResponse: 'ثبت پاسخ',
  NoTechnicalForceAddedYet: 'هنوز هیچ نیروی فنی اضافه نشده است',
  YouCantChooseSimpleEmployeeForShipmentsWitchHasCar:
    'نمی توانید کارگر حمل بار را برای سفارش های دارای خودرو انتخاب کنید، لطفا کارگر(ان) حمل بار را از لیست حذف کنید',
  YouShouldSelectAtLeastOneTechnicalForceForCarFreeShipments:
    'باید حداقل یک نیروی فنی برای سفارش های بدون خودرو انتخاب کنید',
  TemplateCreationTime: 'زمان ثبت الگو',
  DraftCreationTime: 'زمان ثبت پیش نویس',
  furnitureWithCar: 'اسباب‌کشی با خودرو',
  previousLevel: 'مرحله قبل',
  addThisCarIsImpossible: 'امکان اضافه کردن این خودرو وجود ندارد',
  minimumCountForCar_Is_person:
    'حداقل تعداد کارگر برای {carName}، {count} نفر است',
  maximumCountForCar_Is_person:
    'حداکثر تعداد کارگر برای {carName}، {count} نفر است',
  simpleLaborer: 'کارگر حمل بار',
  furnitureType: 'نوع اسباب‌کشی',
  withCar: 'با خودرو',
  withoutCar: 'بدون خودرو',
  expensiveItems: 'اقلام هزینه دار',
  dateAndTime: 'تاریخ و ساعت',
  furnitureDate: 'تاریخ اسباب‌کشی',
  furnitureHour: 'ساعت اسباب‌کشی',
  loadDate: 'تاریخ بارگیری',
  loadHour: 'ساعت بارگیری',
  dischargeDate: 'تاریخ تخلیه',
  dischargeTime: 'زمان تخلیه',
  selectCompany: 'انتخاب پروژه',
  pricing: 'در حال قیمت گذاری ...',
  atLeastSelectOneCompany: 'حداقل یک پروژه انتخاب کنید',
  orderCreatedSuccessfully: 'سفارش با موفقیت ثبت شد',
  creatingOrder: 'در حال ثبت سفارش ...',
  noCompanyFoundBasedOnYourRequest: 'پروژه ای مطابق با درخواست شما یافت نشد',
  atLeastSelectOneCar: 'حداقل یک خودرو انتخاب کنید',
  cargoWeight: 'وزن بار',
  cargoLength: 'طول بار',
  cargoWidth: 'عرض بار',
  cargoHeight: 'ارتفاع بار',
  resumeOrderRegistration: 'ادامه ثبت سفارش',
  saveAsDraft: 'ذخیره به عنوان پیش نویس',
  draftSavedSuccessfully: 'پیش نویس با موفقیت ذخیره شد',
  editDraft: 'ویرایش پیش نویس',
  draftEditedSuccessfully: 'پیش نویس با موفقیت ویرایش شد',
  revertAssign: 'ابطال تخصیص سفارش',
  cancelReason: 'دلیل لغو سفارش',
  cancelDescription: 'توضیحات لغو سفارش',
  distance: 'فاصله',
  startWithoutAssignDriver: 'شروع بدون تخصیص راننده',
  revertStartWithoutAssignDriver: 'ابطال شروع بدون تخصیص راننده',
  assignDriver: 'تخصیص راننده',
  revertAssignDriver: 'ابطال تخصیص راننده',
  customerFeedback: 'بازخورد مشتری',
  loadForwardSteps: 'مراحل جلو بردن سفارش',
  loadRevertSteps: 'مراحل ابطال سفارش',
  draftType: 'نوع پیش نویس',
  draftRange: 'محدوده پیش نویس',
  templateType: 'نوع الگو',
  templateRange: 'محدوده الگو',
  tariff: 'تعرفه ای',
  nonTariff: 'غیر تعرفه ای',
  driverFullName: 'نام و نام خانوادگی راننده',
  driverNationalId: 'شماره ملی راننده',
  diverSuggestedAmount: 'قیمت پیشنهادی راننده',
  vehicleSmartCardNumber: 'کد هوشمند ناوگان',
  vehiclePlate: 'شماره پلاک',
  iran: 'ایران',
  originWeightOfWeighbridge: 'وزن باسکول در مبدا',
  destinationWeightOfWeighbridge: 'وزن باسکول در مقصد',
  originWeighbridgeReceipt: 'رسید باسکول در مبدا',
  destinationWeighbridgeReceipt: 'رسید باسکول در مقصد',
  courierTariffPricing: 'قیمت دهی تعرفه ای',
  courierAuctionPricing: 'قیمت دهی مزایده ای',
  webServicePricing: 'قیمت دهی وب سرویس',
  driverAuctionPricing: 'قیمت دهی مزایده ای راننده',
  registerOriginWeighBridge: 'ثبت باسکول مبدا',
  registerDestinationWeighBridge: 'ثبت باسکول مقصد',
  successfulOriginWeighBridgeUpdate: 'ثبت باسکول در مبدا',
  successfulDestinationWeighBridgeUpdate: 'ثبت باسکول در مقصد'
}
